document.addEventListener('DOMContentLoaded', function() {
  const variantSelector = document.querySelector('[name="id"]');

  function showSelectedVariantContent(selectedVariantId) {
    const containers = document.querySelectorAll('.each-box__container');
    if (!containers.length) return null;
    containers.forEach(container => {
      if (container.dataset.variantId === selectedVariantId) {
        container.classList.remove('hidden');
      } else {
        container.classList.add('hidden');
      }
    });

    const flavourContainers = document.querySelectorAll('.flavour-breakdown__variant');
    flavourContainers.forEach(container => {
      if (container.dataset.variantId === selectedVariantId) {
        container.classList.remove('hidden');
      } else {
        container.classList.add('hidden');
      }
    });
  }

  if (variantSelector) {
    variantSelector.addEventListener('change', function() {
      showSelectedVariantContent(variantSelector.value);
    });

    showSelectedVariantContent(variantSelector.value);
  }
});

document.addEventListener("variant:changed", function(event) {
  const selectedVariant = event.detail.variant;

  const allVariants = document.querySelectorAll('.each-box__container');
  if (!allVariants.length) return null;
  allVariants.forEach(function(container) {
    container.classList.add('hidden');
  });

  const newVariantElement = document.querySelector(`.each-box__container[data-variant-id="${selectedVariant.id}"]`);
  if (newVariantElement) {
    newVariantElement.classList.remove('hidden');
  }

  const flavourElements = document.querySelectorAll(`.flavour-breakdown__variant`);
  flavourElements.forEach(function(flavourElement) {
    if (flavourElement.dataset.variantId === selectedVariant.id.toString()) {
      flavourElement.classList.remove('hidden');
    } else {
      flavourElement.classList.add('hidden');
    }
  });
});
